import React from 'react'

import BreadcrumbBar from 'components/BreadcrumbBar'
import { Container } from 'components/Grid'
import Footer from 'components/Layout/components/Footer'
import Head from 'components/Layout/components/Head'
import Navigation from 'components/NavigationNew/Navigation'
import TrustBanner from 'components/TrustBanner'
import { useAppContext } from 'context/AppContext'
import { useUser } from 'hooks'

import AppBar from './components/AppBar'

import classes from './Layout.module.scss'

/** @type {import('./types').default} */
const Layout = ({ children, isSticky }) => {
  const { head, header, newNavigationTabs, url, hreflangs } = useAppContext()

  const [user] = useUser()
  const hasHead = head && Object.keys(head).filter(key => key !== 'google_analytics').length > 0

  return (
    <main className={classes.layout}>
      {hasHead && <Head metaData={head} url={url} hreflangs={hreflangs} />}
      <AppBar className="Header" user={user} isSticky={isSticky} />
      <Container className={classes.trustBannerContainer}>
        <TrustBanner />
      </Container>
      <BreadcrumbBar breadcrumbs={header?.breadcrumb} route={header?.route} />
      {newNavigationTabs && (
        <Container className={classes.navigationContainer}>
          <Navigation className={classes.navigation} navigationTabs={newNavigationTabs} />
        </Container>
      )}
      <div className={classes.content}>{children}</div>
      <Footer isSignedIn={!!user} />
    </main>
  )
}
export default Layout
